export const getCourses = (state) => state.courses?.courses;
export const getActiveCourseMembers = id => state => state.courses?.activeCourseMembers[id];
export const getActiveCourse = (state) => state.courses?.activeCourse;